import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../config";
import "./ProjectDetailsPage.css";

export default function ProjectDetailsPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  /* ---------- FETCH ---------- */
  useEffect(() => {
    fetch(`${API_URL}/projects/${id}`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : Promise.reject(r.statusText)))
      .then(setData)
      .catch((e) => {
        console.error(e);
        setErr("Nie udało się pobrać projektu.");
      });
  }, [id]);

  if (err) return <p>{err}</p>;
  if (!data) return <p>Ładowanie…</p>;

  const p = data.project;
  const orders = data.orders || [];

  /* ---------- HELPERS ---------- */
  const fmt = (d) => (d ? new Date(d).toLocaleDateString("pl-PL") : "—");

  /* ---------- RENDER ---------- */
  return (
    <div className="project-details-grid">
      {/* ----------- LEWA  3/4 ----------- */}
      <section className="pd-left">
        <h1 className="pd-title">{p.name}</h1>
        <p className="pd-desc">{p.description || "— Brak opisu —"}</p>

        <div className="pd-meta">
          <span><b>Termin zakończenia:</b> {fmt(p.deadline)}</span>
          <span><b>Utworzono:</b> {fmt(p.created_at)}</span>
        </div>

        <h2 className="pd-subtitle">Zlecenia</h2>
        <div className="orders-table-container">
          <table className="orders-table">
            <thead>
              <tr>
                <th>Nr.ref</th>
                <th>Tytuł</th>
                <th>Status</th>
                <th>Utworzono</th>
                <th>Dead­line</th>
                <th>Przydzielony</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id}
                    onClick={() => nav(`/zlecenia/${o.id}`)}
                    className="clickable-row"
                >
                  <td>{o.nr_ref}</td>
                  <td className="title-column">{o.tytul}</td>
                  <td>{o.status}</td>
                  <td>{fmt(o.created_at)}</td>
                  <td>{fmt(o.deadline)}</td>
                  <td>
                    {o.executor_first_name
                      ? `${o.executor_first_name} ${o.executor_last_name}`
                      : "—"}
                  </td>
                </tr>
              ))}

              {orders.length === 0 && (
                <tr>
                  <td colSpan={6} className="no-data">
                    Brak zleceń do wyświetlenia
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

      {/* ----------- PRAWA  1/4 ----------- */}
      <aside className="pd-right">
        <button
          className="btn-submit pd-btn"
          onClick={() => nav(`/zlecenia/nowe?projectId=${id}`)}
        >
          Dodaj Nowe Zlecenie
        </button>
        <button
          className="btn-submit pd-btn"
          onClick={() => nav(`/projekty/${id}/add-orders`)}
        >
          Dodaj Zlecenie
        </button>
      </aside>
    </div>
  );
}
